export default "__VITE_ASSET__OZmkN9qZn5__A_M4yHZG6g__"